import { render, staticRenderFns } from "./animate.vue?vue&type=template&id=3f8435f0&"
import script from "./animate.vue?vue&type=script&lang=js&"
export * from "./animate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports